// Share only in-flight requests, including React's development effect remount.
const requests = new Map();
const welcomes = new Set();

export function checkDailyLogin(api, userId) {
  if (!requests.has(userId)) {
    const request = api.post("/game/login-rewards").then(({ data }) => data);
    requests.set(userId, request);
    const clear = () => { if (requests.get(userId) === request) requests.delete(userId); };
    request.then(clear, clear);
  }
  return requests.get(userId);
}

export function claimDailyWelcome(userId, data) {
  const key = JSON.stringify([userId, data.date]);
  if (!data.new_day || welcomes.has(key)) return false;
  welcomes.add(key);
  return true;
}

export function earnedPuzzles(rewards = []) {
  return [...new Map(rewards.filter(reward => reward.puzzle_id).map(reward => [reward.puzzle_id, reward])).values()].reverse();
}
